module.exports = __webpack_public_path__ + "img/mast_communications.04517f71.svg";